import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from 'react';
import Notiflix from 'notiflix';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import smoothScrollIntoView from 'smooth-scroll-into-view-if-needed';
import axios, { AxiosResponse } from 'axios';
import { v4 } from 'uuid';
import Button from '../../components/Button';

import FormWrapper from '../../components/FormWrapper';
import Modal2 from '../../components/Modal2';
import Select, { SelectHandles } from '../../components/Select';
import api from '../../services/api/api';

import Input from '../../components/Input';
import DatePicker from '../../components/DatePicker';
import InputFile, { InputFileHandles } from '../../components/InputFile';
import { TitleIntern } from '../../components/Title';
import { RowProps } from '.';
import { dateToPTBR } from '../../utils/formatt';
import getValidationErrors, { TestaCPF } from '../../utils/getValidationErrors';
import { EnterpriseUser, UserCommon, useAuth } from '../../hooks/auth';
import { downloadFileOfBlob } from '../../utils/geterateFileURL';
import { ModalButtonContainer } from '../BeneficiaryInclude/styles';
import SelectUnform from '../../components/SelectUnform';
import { OptionalParams } from './styles';
import DatePickerUnform from '../../components/DatePickerUnform';
import BlockInsideForm from '../../components/BlockInsideForm';
import { isOver18 } from '../../utils/dateUtil';

import GenericService from '../../services/api/modules/generic.service';

interface DepentendIncludeProps {
  defaultColor: string;
  callbackSetStep: (prev: number) => void;
  rowsSelecteds: RowProps[];
  showTitle: boolean;
  showActionsButtons?: boolean;
  contractId?: string;
  selectedProduct?: string;
  showNewButton?: boolean;
  isExternalLink?: boolean;
  preloadOfRequestId?: string;
  initialAllDisable?: boolean;
  requestHolderId?: string;
  callbackShowReleaseButton?: () => void;
}

export interface DependentIncludeHandles {
  containAllFiles(): boolean;
  saveAndRelease: () => Promise<boolean>;
  firstContainerRefError(): HTMLDivElement | null;
  validateForm(): Promise<void>;
  dispatchSaveEdit(): Promise<string>;
}
interface AttachmentRules {
  beneficiaryType: string;
  id: string;
  mandatory: string;
  name: string;
  relationship: string;
}

interface DateProps {
  value: Date | null;
  error: string;
}

const DepentendInclude: React.ForwardRefRenderFunction<
  DependentIncludeHandles,
  DepentendIncludeProps
> = (
  {
    defaultColor,
    callbackSetStep,
    rowsSelecteds,
    showTitle = true,
    isExternalLink = false,
    preloadOfRequestId,
    initialAllDisable = false,
    showNewButton = true,
    requestHolderId: requestHolderIdProps,
    callbackShowReleaseButton,
    showActionsButtons = true,
    contractId,
    selectedProduct,
  },
  ref,
) => {
  const { user: userT } = useAuth();
  const user = userT as UserCommon & EnterpriseUser;

  const formRef = useRef<FormHandles>(null);
  const formRef2 = useRef<FormHandles>(null);
  const formRef3 = useRef<FormHandles>(null);
  const otherFormRef = useRef<FormHandles>(null);
  const parentsRefResponsible = useRef<SelectHandles>(null);
  const countryRef = useRef<SelectHandles>(null);
  const nationalityRef = useRef<SelectHandles>(null);
  const stateRef = useRef<SelectHandles>(null);
  const cityRef = useRef<SelectHandles>(null);
  const ufRef = useRef<SelectHandles>(null);
  const maritalRef = useRef<SelectHandles>(null);
  const phisicalSexRef = useRef<SelectHandles>(null);
  const [disabled, setDisabled] = useState<boolean>(initialAllDisable);
  const [requestHolderId, setRequestHolderId] = useState(requestHolderIdProps);
  const [idOfOwnerRequiredByContract, setIdOfOwnerRequiredByContract] =
    useState<string | null>(null);
  const [requestId, setRequestId] = useState('');

  const [hiddenRelease, setHiddenRelease] = useState(false);
  const [refreshedAttachments, refreshAttachments] = useState('');

  const attachmentsRefs = useRef<InputFileHandles[]>([]);
  const [allAttachmentsTypes, setAllAttachmentsTypes] = useState(
    [] as AttachmentRules[],
  );
  const [attachmentsTypes, setAttachmentsTypes] = useState(
    [] as AttachmentRules[],
  );

  const [parents, setParents] = useState('');
  const [responsibleParentsOptions, setResponsibleParentsOptions] = useState([
    { title: '', value: '' },
  ]);

  const [rawParentsOptions, setRawParentsOptions] = useState([
    { name: '', id: -1, needRespLegal: false, needLegalGuardian: false },
  ]);

  const [countryOptions, setCountryOptions] = useState([
    { title: 'País', value: '' },
  ]);

  const [nationalityOptions, setNationalityOptions] = useState([
    { title: 'Nacionalidade', value: '' },
  ]);

  const [statesOptions, setStateOptions] = useState([
    { title: 'Estado', value: '' },
  ]);

  const [cityOptions, setCityOptions] = useState([
    { title: 'Cidades', value: '' },
  ]);

  const [ufOptions, setUfOptions] = useState([{ title: 'UF', value: '' }]);
  const [maritalOptions, setMaritalOptions] = useState([
    { title: 'Estado civil', value: '' },
  ]);

  const [phisicalSexOptions, setPhisicalSexOptions] = useState([
    { title: 'Sexo', value: '' },
  ]);

  const [reasonForInclusionOptions, setReasonForInclusionOptions] = useState([
    { title: 'Razão', value: '' },
  ]);
  const [includeReason, setIncludeReason] = useState({ name: '', id: '' });

  const [birthDate, setBirthDate] = useState<DateProps>({
    value: null,
    error: '',
  });
  const [responsibleBirth, setResponsibleBirth] = useState<DateProps>({
    value: null,
    error: '',
  });

  const [rgDispatchDate, setRgDispatchDate] = useState<DateProps>({
    value: null,
    error: '',
  });

  const [responsibleDegreeKinship, setParentsResponsible] = useState<
    number | string
  >('');

  const [showInputOtherParents, setShowInputOtherParents] = useState(false);

  const [responsibleData, setResponsibleData] = useState<any>({});

  const [showLegaLRespBlock, setShowLegaLRespBlock] = useState({
    over18: false,
    needRespLegal: false,
  });

  const handleReport = useCallback(
    async (request: string) => {
      try {
        Notiflix.Block.circle(`.notiflix-dependent-report-${request}`);
        const { data } = await api.get(
          `/report/list-of-company-portal-reports?contractId=${user.id}&exhibitionLocation=2`,
        );
        const { nrSeqRelatorio, Parametros: P } = data.content[0];
        const body = {
          nrSeqRelatorio: nrSeqRelatorio ?? '',
          Parametros: [
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...P.map((p: { cdParametro: any }) => {
              return {
                id: p.cdParametro,
                valor: request,
              };
            }),
          ],
        };

        const { data: dataReport, headers } = await api.post(
          `/report/generate-report`,
          body,
          {
            responseType: 'blob',
          },
        );
        downloadFileOfBlob(dataReport, { headersRequest: headers });
      } catch (err) {
        if (err?.response?.status === 400) {
          Notiflix.Notify.info(err.response.data?.message);
        } else {
          Notiflix.Notify.failure(
            'Não conseguimos buscar seu relatório. Tente novamente mais tarde.',
          );
        }
      } finally {
        Notiflix.Block.remove(`.notiflix-dependent-report-${request}`);
      }
    },
    [user],
  );

  const handleReleaseRegister = useCallback(
    async (request: string) => {
      try {
        const { data } = await api.put(
          `/company/release-dependent-registered`,
          {
            requestId: request,
            origin: 'Inclusao',
          },
        );
        const { message } = data;
        Modal2.Close();
        Notiflix.Notify.success(message);
        setHiddenRelease(true);
        if (!isExternalLink && (!requestHolderId || showActionsButtons)) {
          callbackSetStep(1);
        }
      } catch (err) {
        Modal2.Close();
        if (axios.isAxiosError(err) && err.response?.data?.message) {
          Modal2.Failure({
            closable: true,
            autoWidth: true,
            title: 'Ooops...',
            text: err.response.data?.message,
            children: (
              <Button modal onClick={() => Modal2.Close()}>
                Ok
              </Button>
            ),
          });
        } else {
          Notiflix.Notify.failure(
            'Ops... Não conseguimos liberar esse registro no servidor no momento. Por favor, tente novamente mais tarde.',
          );
        }
      }
    },
    [isExternalLink, requestHolderId, showActionsButtons, callbackSetStep],
  );

  const handleOpenInconsistency = useCallback(async (id) => {
    try {
      Notiflix.Block.circle('notiflix-button');
      const { data } = await api.get(
        `/company/get-inconsistency-inclusion?requestNumber=${id}`,
      );
      if (data.result !== 2) {
        const { data: realData } = data;
        const text = realData.map((e: any) => {
          return (
            <p key={e.inconsistencyDescription.slice(0, 10)}>
              {e.inconsistencyDescription}
            </p>
          );
        });

        if (!data) {
          return;
        }

        Modal2.Generic({
          closable: true,
          title: 'Inconsistências',
          autoWidth: true,
          text,
        });
      }
    } catch (err: any) {
      if (err.response?.data?.message) {
        Notiflix.Notify.info(err.response.data.message);
      } else {
        Notiflix.Notify.failure(
          'Ops... Não conseguimos buscar o relatório no servidor. Por favor, tente novamente mais tarde.',
        );
      }
    } finally {
      Notiflix.Block.remove('notiflix-button');
    }
  }, []);

  const clearFormErrors = useCallback(() => {
    parentsRefResponsible.current?.setError('');
    formRef3.current?.setErrors({});
    formRef.current?.setErrors({});
    setRgDispatchDate((prev) => ({
      ...prev,
      error: '',
    }));
  }, []);

  const validateForm = useCallback(async () => {
    const data = formRef.current?.getData() ?? {};
    try {
      clearFormErrors();

      // eslint-disable-next-line no-underscore-dangle
      const _responsibleData = formRef3.current?.getData() ?? {};
      _responsibleData.parentsResponsible =
        parentsRefResponsible.current?.value;

      if (showLegaLRespBlock.needRespLegal && showLegaLRespBlock.over18) {
        const schema = Yup.object().shape({
          responsibleName: Yup.string()
            .required('Informe o nome do responsável.')
            .test(
              'notEqualName',
              'Informe um nome diferente do dependente.',
              function (value) {
                return value !== data?.dependentName;
              },
            ),
          responsibleCpf: Yup.string()
            .required('Informe o documento do responsável.')
            .test(
              'notEqual',
              'Informe um documento diferente do dependente.',
              function (value) {
                return value !== data?.cpf;
              },
            ),
          responsibleEmail: Yup.string().required(
            'Informe o email do responsável.',
          ),
          responsiblePhone: Yup.string().required(
            'Informe o telefone do responsável.',
          ),
          parentsResponsible: Yup.string().required(
            'Informe o grau de parentesco.',
          ),
        });

        if (!responsibleBirth.value) {
          setResponsibleBirth((prev) => ({
            ...prev,
            error: 'Informe uma data.',
          }));
        } else if (
          responsibleBirth &&
          birthDate &&
          birthDate.value &&
          responsibleBirth.value.toString() === birthDate.value.toString()
        ) {
          setResponsibleBirth((prev) => ({
            ...prev,
            error: 'Informe uma data diferente do dependente.',
          }));
        }

        if (
          Number(responsibleDegreeKinship) === 99 &&
          otherFormRef.current?.getFieldValue(
            'responsibleDegreeKinshipDescription',
          ) === ''
        ) {
          otherFormRef.current?.setErrors({
            responsibleDegreeKinshipDescription:
              'Informe o grau de parentesco.',
          });
        }

        await schema.validate(_responsibleData, { abortEarly: false });
      }

      nationalityRef.current?.setError(
        !nationalityRef.current?.value ? 'Informe uma nacionalidade.' : '',
      );

      maritalRef.current?.setError(
        !maritalRef.current?.value ? 'Informe uma estado civil.' : '',
      );

      countryRef.current?.setError('');

      ufRef.current?.setError('');

      if (!birthDate.value) {
        setBirthDate((prev) => ({ ...prev, error: 'Informe uma data.' }));
      }

      // if (!effectiveDate.value) {
      //   setEffectiveDate((prev) => ({ ...prev, error: 'Informe uma data.' }));
      // }

      let hasError = false;

      const beneficiaryUnderAgeValidation = {};

      if (!data?.reasonForInclusion) {
        formRef.current?.setFieldError(
          'reasonForInclusion',
          'Informe um motivo.',
        );
        hasError = true;
      }
      if (nationalityRef.current?.value === '10') {
        stateRef.current?.setError(
          !stateRef.current?.value ? 'Informe um estado.' : '',
        );
        cityRef.current?.setError(
          !cityRef.current?.value ? 'Informe uma cidade.' : '',
        );

        if (birthDate.value) {
          const birthDateFormatted = dateToPTBR(birthDate.value);
          const [, , year] = birthDateFormatted.split('/');
          const age = new Date().getFullYear() - Number(year);
          // if (nationalityRef.current?.value === '10') {
          if (age > 14) {
            if (formRef.current?.getFieldValue('rg').length < 2) {
              Object.assign(beneficiaryUnderAgeValidation, {
                rg: Yup.string().required('Informe o RG.'),
              });
            }
            if (!rgDispatchDate.value) {
              setRgDispatchDate((prev) => ({
                ...prev,
                error:
                  'O dependente maior de 14 anos deve ter a Data Exp. RG preenchido.',
              }));
              hasError = true;
            }

            if (!countryRef.current?.value) {
              countryRef.current?.setError('Informe um país');
              hasError = true;
            }

            if (!formRef.current?.getFieldValue('organ')) {
              Object.assign(beneficiaryUnderAgeValidation, {
                organ: Yup.string().required('Informe o orgão.'),
              });
            }

            ufRef.current?.setError(
              !ufRef.current?.value ? 'Informe o estado.' : '',
            );
          }
        }
      }
      if (data?.cpf && data?.responsibleCpf && !TestaCPF(data.cpf)) {
        formRef.current?.setFieldError('cpf', 'Informe um cpf válido.');
        hasError = true;
      }

      const noBirthdateValidation = {};
      if (!birthDate.value) {
        if (formRef.current?.getFieldValue('rg').length < 2) {
          Object.assign(noBirthdateValidation, {
            rg: Yup.string().required(
              'Informe a data de nascimento para preencher o rg.',
            ),
          });
        }
        if (nationalityRef.current?.value === '10') {
          if (!rgDispatchDate.value) {
            setRgDispatchDate((prev) => ({
              ...prev,
              error:
                'Informe a data de nascimento para prencher a Data Exp. RG.',
            }));
            hasError = true;
          }
        }
        if (!countryRef.current?.value) {
          countryRef.current?.setError(
            'Informe a data de nascimento para preencher País Emissor.',
          );
          hasError = true;
        }

        if (!phisicalSexRef.current?.value) {
          phisicalSexRef.current?.setError('Informe seu sexo.');
          hasError = true;
        }

        if (!formRef.current?.getFieldValue('organ')) {
          Object.assign(noBirthdateValidation, {
            organ: Yup.string().required(
              'Informe a data de nascimento para preencher o orgão.',
            ),
          });
        }

        ufRef.current?.setError(
          !ufRef.current?.value
            ? 'Informe a data de nascimento para preencher a UF.'
            : '',
        );
      }

      const schema = Yup.object().shape({
        dependentName: Yup.string().required('Informe o nome do dependente.'),
        // responsible: Yup.string().required(
        //   "Informe o nome do responsável."
        // ),
        phone: Yup.string().required('Informe um telefone'),
        cellphone: Yup.string().required('Informe um celular'),
        // responsibleDddCellPhone: Yup.string().required("Informe um telefone"),
        cpf: Yup.string().required('Informe o CPF.'),
        // responsibleCpf: Yup.string().required("Informe o CPF."),
        // rg: Yup.string().required(
        //   'O dependente maior de 14 anos deve ter o RG preenchidoa.',
        // ),
        // organ: Yup.string().required('Informe o órgão.'),
        father: Yup.string().required('Informe o nome do pai.'),
        mother: Yup.string().required('Informe o nome da mãe.'),
        organ: Yup.string(),
        rg: Yup.string(),
        parents: Yup.string().required('Informe o grau de parentesco'),
        ...beneficiaryUnderAgeValidation,
        ...noBirthdateValidation,
      });

      await schema.validate(data, { abortEarly: false });

      if (
        // !parentesRef.current?.value ||
        // !parentsRefResponsible.current?.value ||
        // !nationalityRef.current?.value ||
        // !stateRef.current?.value ||
        // !cityRef.current?.value ||
        !maritalRef.current?.value ||
        !phisicalSexRef.current?.value ||
        !birthDate.value ||
        // !responsibleBirth.value ||
        // !effectiveDate.value ||
        // !reasonForInclusion.value ||
        hasError
      ) {
        throw new Error('Alguns campos necessários estão vazios.');
      }
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        formRef3.current?.setErrors(errors);
        formRef.current?.setErrors(errors);

        if (errors.parentsResponsible) {
          parentsRefResponsible.current?.setError(errors.parentsResponsible);
        }
        const scrollToFirstError = formRef.current?.getFieldRef(
          Object.keys(errors)[0],
        );
        if (scrollToFirstError) {
          const el: HTMLElement = scrollToFirstError.current;
          smoothScrollIntoView(el, { behavior: 'smooth' });
        }
      }

      throw new Error('Alguns campos necessários estão vazios.');
    }
  }, [
    clearFormErrors,
    showLegaLRespBlock,
    birthDate,
    responsibleBirth,
    responsibleDegreeKinship,
    rgDispatchDate.value,
  ]);

  useEffect(() => {
    try {
      const conditions =
        (birthDate.value && !isOver18(birthDate.value)) ?? false;

      setShowLegaLRespBlock((prev) => ({ ...prev, over18: conditions }));
    } catch (error) {
      console.log(error);
    }
  }, [birthDate]);

  useEffect(() => {
    const parent = rawParentsOptions.find(
      (item) => String(item.id) === String(parents),
    );

    if (parent) {
      setShowLegaLRespBlock((prev) => ({
        ...prev,
        needRespLegal: parent.needLegalGuardian ?? false,
      }));
    }
  }, [parents, rawParentsOptions]);

  const setResponsibleOtherDescriptionField = useCallback(() => {
    otherFormRef.current?.setFieldValue(
      'responsibleDegreeKinshipDescription',
      responsibleData?.responsibleDegreeKinshipDescription || '',
    );
  }, [responsibleData]);

  const setResponsibleFields = useCallback(() => {
    try {
      if (Object.values(responsibleData).length === 0) return;

      formRef3.current?.setFieldValue(
        'responsibleName',
        responsibleData.responsibleName ?? '',
      );
      formRef3.current?.setFieldValue(
        'responsibleCpf',
        responsibleData.responsibleCpf ?? '',
      );

      formRef3.current?.setFieldValue(
        'responsibleCellPhone',
        responsibleData.responsibleCellPhone ?? '',
      );
      formRef3.current?.setFieldValue(
        'responsiblePhone',
        responsibleData.responsibleCellPhone
          ? responsibleData.responsibleDddCellPhone +
              responsibleData.responsibleCellPhone
          : '',
      );
      formRef3.current?.setFieldValue(
        'responsibleDegreeKinship',
        responsibleData.responsibleDegreeKinship ?? '',
      );
      formRef3.current?.setFieldValue(
        'responsibleEmail',
        responsibleData.responsibleEmail ?? '',
      );
      formRef3.current?.setFieldValue(
        'responsibleDegreeKinshipDescription',
        responsibleData.responsibleDegreeKinshipDescription ?? '',
      );

      parentsRefResponsible.current?.setValue(
        '',
        String(responsibleData.responsibleDegreeKinship),
      );

      // eslint-disable-next-line eqeqeq
      if (String(responsibleData.responsibleDegreeKinship) === '99') {
        setShowInputOtherParents(true);
      }

      setParentsResponsible(responsibleData.responsibleDegreeKinship ?? '');

      if (responsibleData.responsibleBirth) {
        const [birthDay, birthMonth, birthYear] =
          responsibleData.responsibleBirth.split('/');
        setResponsibleBirth({
          value: new Date(birthYear, birthMonth - 1, birthDay),
          error: '',
        });
      } else {
        setResponsibleBirth({
          value: null,
          error: '',
        });
      }
    } catch (error) {
      console.log(error);
    }
  }, [responsibleData]);

  useEffect(() => {
    if (showLegaLRespBlock.over18 && showLegaLRespBlock.needRespLegal) {
      setResponsibleFields();
    }
  }, [showLegaLRespBlock, responsibleData, setResponsibleFields]);

  useEffect(() => {
    if (
      showLegaLRespBlock.over18 &&
      showLegaLRespBlock.needRespLegal &&
      showInputOtherParents
    ) {
      setResponsibleOtherDescriptionField();
    }
  }, [
    setResponsibleOtherDescriptionField,
    showInputOtherParents,
    showLegaLRespBlock.needRespLegal,
    showLegaLRespBlock.over18,
  ]);

  const handleSubmit = useCallback(
    async (data, notiflix): Promise<string> => {
      try {
        Notiflix.Block.circle(notiflix);

        // eslint-disable-next-line no-shadow
        let responsibleData;
        if (!showLegaLRespBlock.needRespLegal && !showLegaLRespBlock.over18) {
          formRef3.current?.reset();
          otherFormRef.current?.reset();
          setParentsResponsible(0);
          setResponsibleBirth({
            value: null,
            error: '',
          });
        }

        // eslint-disable-next-line prefer-const
        responsibleData = formRef3.current?.getData();
        if (responsibleData) {
          responsibleData!.responsibleDegreeKinshipDescription =
            otherFormRef.current
              ? otherFormRef.current?.getData()
                  .responsibleDegreeKinshipDescription
              : '';
        }
        await validateForm();
        const files = attachmentsTypes.reduce((acc, act) => {
          if (attachmentsRefs.current[Number(act.id)].files !== null) {
            attachmentsRefs.current[Number(act.id)].files?.forEach((f) => {
              acc.push(f);
            });
          }
          return acc;
        }, [] as File[]);
        const toSend = new FormData();

        // preference to rowSelected
        toSend.append('contractId', rowsSelecteds[0].contractId ?? contractId);

        // if is external link use rowSelected
        toSend.append(
          'webUsername',
          isExternalLink ? rowsSelecteds[0].webUsername : user.webUsername,
        );

        if (!requestHolderId) {
          const value =
            (rowsSelecteds[0].userUnimedId
              ? String(rowsSelecteds[0].userUnimedId)
              : undefined) ??
            idOfOwnerRequiredByContract ??
            '';
          toSend.append('userUnimedIdHolder', value);
        } else {
          toSend.append('requestHolderId', requestHolderId);
        }
        toSend.append('previousRequestId', requestId || data.previousRequestId);
        toSend.append('dependentName', data.dependentName);

        toSend.append(
          'responsibleName',
          responsibleData?.responsibleName ?? '',
        );
        toSend.append(
          'responsibleBirth',
          responsibleBirth.value ? dateToPTBR(responsibleBirth.value) : '',
        );
        toSend.append(
          'responsibleEmail',
          responsibleData?.responsibleEmail ?? '',
        );

        // toSend.append(
        //   "responsibleDddCellPhone",
        //   responsibleData?.responsiblePhone.slice(0, 2) ?? ""
        // );
        toSend.append(
          'responsibleDddCellPhone',
          responsibleData?.responsiblePhone.slice(0, 2) ?? '',
        );
        toSend.append(
          'responsibleCellPhone',
          responsibleData?.responsiblePhone.slice(2) ?? '',
        );
        toSend.append(
          'responsibleDegreeKinship',
          parentsRefResponsible.current?.value ?? '',
        );
        toSend.append(
          'responsibleDegreeKinshipDescription',
          responsibleData?.responsibleDegreeKinshipDescription ?? '',
        );

        toSend.append('email', data.email);
        toSend.append('planId', data.product ?? '');

        toSend.append('relationshipNumber', data.parents ?? '');
        toSend.append(
          'birthDate',
          birthDate.value ? dateToPTBR(birthDate.value) : '',
        );
        {
          const [dddNumberPhone, phone] = [
            data.phone.slice(0, 2),
            data.phone.slice(2),
          ];
          toSend.append('dddNumberPhone', dddNumberPhone);
          toSend.append('phone', phone);
        }
        {
          const [dddCellPhone, cellphone] = [
            data.cellphone.slice(0, 2),
            data.cellphone.slice(2),
          ];
          toSend.append('dddCellPhone', dddCellPhone);
          toSend.append('cellphone', cellphone);
        }

        const titleCityOfBirth = cityOptions.find(
          (i) => i.value === cityRef.current?.value,
        );

        if (titleCityOfBirth) {
          toSend.append('municipalityOfBirth', titleCityOfBirth.title);
        }

        toSend.append('initialsBirthState', stateRef.current?.value ?? '');
        toSend.append('cpf', data.cpf);
        toSend.append('responsibleCpf', responsibleData?.responsibleCpf ?? '');
        toSend.append('rg', data.rg);
        toSend.append('issuingAgency', data.organ);
        toSend.append(
          'brazilianstatesWhichIssuedRg',
          ufRef.current?.value ?? '',
        );
        if (rgDispatchDate.value) {
          toSend.append('emissionDate', dateToPTBR(rgDispatchDate.value));
        }
        toSend.append('issuingAgencyCountry', countryRef.current?.value ?? '');
        toSend.append('maritalStatus', maritalRef.current?.value ?? '');
        toSend.append('sex', phisicalSexRef.current?.value ?? '');
        toSend.append('motherName', data.mother);
        toSend.append('fatherName', data.father);
        toSend.append('motiveIncludeId', data.reasonForInclusion);
        toSend.append('datePlanAgreementOrigin', data.contractDateOfOriginPlan);
        toSend.append(
          'sourcePlanPriceValue',
          String(Number(data.priceOfOriginPlan) / 100).replace(',', '.'),
        );
        toSend.append('ansGuideProtocolNumber', data.ANSGuideProtocolNumber);
        toSend.append('protocolIssueDate', data.issueProtocolDate);
        toSend.append('descriptionOperatorOrigin', data.originOperator);
        toSend.append(
          'codeCoveragePlanOrigin',
          data.coverageGeographicalOriginalPlan,
        );
        toSend.append(
          'sourcePlanRegistrationCode',
          data.registerOfOriginalProduct,
        );
        toSend.append('typePlanContractOrigin', data.typeOfContract);

        toSend.append('passportId', data.passportNumber);

        toSend.append('nationalityCode', nationalityRef.current?.value ?? '');

        files.forEach((f: Blob, index: number) => {
          toSend.append(`dependentsFiles[${index}]`, f);
        });

        const { data: dataApi } = await api.post(
          '/beneficiary-inclusion/add-dependent',
          toSend,
        );
        const { content, message } = dataApi;

        setRequestId(content[0].requestId);

        if (isExternalLink) {
          Modal2.Success({
            closable: false,
            autoWidth: true,
            title: 'Perfeito!',
            subtitle: message,
            text: 'Deseja adicionar um dependente?',
            children: (
              <ModalButtonContainer>
                <Button
                  modal
                  outlined
                  onClick={() => {
                    Modal2.Close();
                    window.location.href =
                      'https://portal.unimedblumenau.com.br';
                  }}
                >
                  Sair
                </Button>
                <Button
                  modal
                  onClick={() => {
                    Modal2.Close();
                  }}
                >
                  Sim
                </Button>
              </ModalButtonContainer>
            ),
          });
          setDisabled(true);
          // return '';
        } else if (requestHolderId) {
          Notiflix.Notify.success(message);
        } else {
          Modal2.Success({
            closable: true,
            autoWidth: true,
            title: 'Perfeito!',
            text: message,
            children: (
              <Button modal onClick={() => Modal2.Close()}>
                Ok
              </Button>
            ),
          });
        }
        handleOpenInconsistency(content[0].requestId);

        return content[0].requestId;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.data?.message) {
          Modal2.Failure({
            closable: true,
            autoWidth: true,
            title: 'Ooops...',
            text: err.response.data.message,
            children: (
              <Button modal onClick={() => Modal2.Close()}>
                Ok
              </Button>
            ),
          });
        } else if (axios.isAxiosError(err)) {
          Notiflix.Notify.failure(
            'Ops... Algo deu errado ao tentar processar sua solicitação. Por favor, tente novamente mais tarde.',
          );
        }
        return '';
      } finally {
        Notiflix.Block.remove(notiflix);
      }
    },
    [
      validateForm,
      attachmentsTypes,
      rowsSelecteds,
      contractId,
      isExternalLink,
      user.webUsername,
      requestHolderId,
      requestId,
      birthDate,
      showLegaLRespBlock,
      responsibleBirth,
      cityOptions,
      rgDispatchDate,
      handleOpenInconsistency,
      idOfOwnerRequiredByContract,
    ],
  );

  const handleSubmitEdit = useCallback(
    async (
      data = formRef.current?.getData(),

      notiflix = `.notiflix-dependent-send-edit-${requestId}`,
    ): Promise<string> => {
      try {
        // eslint-disable-next-line no-shadow
        let responsibleData;
        if (!showLegaLRespBlock.needRespLegal && !showLegaLRespBlock.over18) {
          formRef3.current?.reset();
          otherFormRef.current?.reset();
          setParentsResponsible(0);
          setResponsibleBirth({
            value: null,
            error: '',
          });
        }

        // eslint-disable-next-line prefer-const
        responsibleData = formRef3.current?.getData();
        if (responsibleData) {
          responsibleData!.responsibleDegreeKinshipDescription =
            otherFormRef.current
              ? otherFormRef.current?.getData()
                  .responsibleDegreeKinshipDescription
              : '';
        }

        await validateForm();
        Notiflix.Block.circle(notiflix);
        const files = attachmentsTypes.reduce((acc, act) => {
          if (attachmentsRefs.current[Number(act.id)].files !== null) {
            attachmentsRefs.current[Number(act.id)].files?.forEach((f) => {
              acc.push(f);
            });
          }
          return acc;
        }, [] as File[]);

        const toSend = new FormData();
        if (rowsSelecteds[0].contractId) {
          toSend.append('contractId', rowsSelecteds[0].contractId);
        } else if (contractId) {
          toSend.append('contractId', contractId);
        }
        toSend.append('webUsername', user.webUsername);

        if (!requestHolderId) {
          toSend.append(
            'userUnimedIdHolder',
            (rowsSelecteds[0].userUnimedId &&
              String(rowsSelecteds[0].userUnimedId)) ||
              idOfOwnerRequiredByContract ||
              '',
          );
        } else {
          toSend.append('requestHolderId', requestHolderId);
        }
        toSend.append('dependentName', data.dependentName);
        toSend.append(
          'responsibleName',
          responsibleData?.responsibleName ?? '',
        );
        toSend.append(
          'responsibleEmail',
          responsibleData?.responsibleEmail ?? '',
        );
        toSend.append('email', data.email);
        toSend.append('planId', data.product);
        toSend.append('relationshipNumber', data.parents ?? '');
        toSend.append(
          'birthDate',
          birthDate.value ? dateToPTBR(birthDate.value) : '',
        );
        toSend.append(
          'responsibleBirth',
          responsibleBirth.value ? dateToPTBR(responsibleBirth.value) : '',
        );
        {
          const [dddNumberPhone, phone] = [
            data.phone.slice(0, 2),
            data.phone.slice(2),
          ];
          toSend.append('dddNumberPhone', dddNumberPhone);
          toSend.append('phone', phone);
        }
        {
          const [dddCellPhone, cellphone] = [
            data.cellphone.slice(0, 2),
            data.cellphone.slice(2),
          ];
          toSend.append('dddCellPhone', dddCellPhone);
          toSend.append('cellphone', cellphone);
        }

        toSend.append(
          'responsibleDddCellPhone',
          responsibleData?.responsiblePhone.slice(0, 2) ?? '',
        );
        toSend.append(
          'responsibleCellPhone',
          responsibleData?.responsiblePhone.slice(2) ?? '',
        );
        const titleCityOfBirth = cityOptions.find(
          (i) => i.value === cityRef.current?.value,
        );

        if (titleCityOfBirth) {
          toSend.append('municipalityOfBirth', titleCityOfBirth.title);
        }
        toSend.append('initialsBirthState', stateRef.current?.value ?? '');
        toSend.append('cpf', data.cpf);
        toSend.append('responsibleCpf', responsibleData?.responsibleCpf ?? '');
        toSend.append('rg', data.rg);
        toSend.append('issuingAgency', data.organ);
        toSend.append(
          'brazilianstatesWhichIssuedRg',
          ufRef.current?.value ?? '',
        );
        if (rgDispatchDate.value) {
          toSend.append('emissionDate', dateToPTBR(rgDispatchDate.value));
        }
        toSend.append('issuingAgencyCountry', countryRef.current?.value ?? '');
        toSend.append('maritalStatus', maritalRef.current?.value ?? '');
        toSend.append('sex', phisicalSexRef.current?.value ?? '');
        toSend.append(
          'responsibleDegreeKinship',
          parentsRefResponsible.current?.value ?? '',
        );
        toSend.append(
          'responsibleDegreeKinshipDescription',
          responsibleData?.responsibleDegreeKinshipDescription ?? '',
        );

        toSend.append('motherName', data.mother);
        toSend.append('fatherName', data.father);
        toSend.append('motiveIncludeId', data.reasonForInclusion);
        toSend.append('datePlanAgreementOrigin', data.contractDateOfOriginPlan);
        toSend.append(
          'sourcePlanPriceValue',
          String(Number(data.priceOfOriginPlan) / 100).replace('.', ','),
        );
        toSend.append('ansGuideProtocolNumber', data.ANSGuideProtocolNumber);
        toSend.append('protocolIssueDate', data.issueProtocolDate);
        toSend.append('descriptionOperatorOrigin', data.originOperator);
        toSend.append(
          'codeCoveragePlanOrigin',
          data.coverageGeographicalOriginalPlan,
        );
        toSend.append(
          'sourcePlanRegistrationCode',
          data.registerOfOriginalProduct,
        );
        toSend.append('typePlanContractOrigin', data.typeOfContract);
        toSend.append('passportId', data.passportNumber);
        toSend.append('nationalityCode', nationalityRef.current?.value ?? '');

        toSend.append('requestId', requestId);
        toSend.append('previousRequestId', requestId || data.previousRequestId);

        files.forEach((f: Blob, index: number) => {
          toSend.append(`dependentsFiles[${index}]`, f);
        });

        const { data: dataApi } = await api.post(
          '/beneficiary-inclusion/add-dependent',
          toSend,
        );

        Notiflix.Block.remove(notiflix);

        const { message } = dataApi;

        Notiflix.Notify.success(message);
        handleOpenInconsistency(requestId);
        return requestId;
      } catch (err) {
        console.log(err);
        if (axios.isAxiosError(err) && err.response?.data?.message) {
          Notiflix.Block.remove(notiflix);
          Modal2.Failure({
            closable: true,
            autoWidth: true,
            title: 'Ooops...',
            text: err.response.data.message,
            children: (
              <Button modal onClick={() => Modal2.Close()}>
                Ok
              </Button>
            ),
          });
        } else if (axios.isAxiosError(err)) {
          Notiflix.Block.remove(notiflix);
          Notiflix.Notify.failure(
            'Ops... Algo deu errado ao tentar processar sua solicitação. Por favor, tente novamente mais tarde.',
          );
        }
        return '';
      }
    },
    [
      requestId,
      showLegaLRespBlock,
      validateForm,
      attachmentsTypes,
      rowsSelecteds,
      contractId,
      user.webUsername,
      requestHolderId,
      birthDate.value,
      responsibleBirth.value,
      cityOptions,
      rgDispatchDate.value,
      handleOpenInconsistency,
      idOfOwnerRequiredByContract,
    ],
  );

  const getAllParents = useCallback(async () => {
    try {
      Notiflix.Block.circle('.notiflix-parents');

      const content = await GenericService.getRelationShip();
      const emptyOption = { value: '-1', title: '' };

      setRawParentsOptions(
        content.map((op) => ({
          id: op.id,
          name: op.name,
          needLegalGuardian: op.needLegalGuardian ?? false,
          needRespLegal: op.needRespLegal ?? false,
        })),
      );

      setResponsibleParentsOptions([
        emptyOption,
        ...content
          .filter((op) => op.typeKinship === 'RESP')
          .map((op) => ({
            title: op.name,
            value: String(op.id),
          })),
      ]);
    } catch (err) {
      Notiflix.Notify.failure(
        'Ops... Não conseguimos buscar a lista de parentes do servidor. Por favor, tente novamente mais tarde.',
      );
    } finally {
      Notiflix.Block.remove('.notiflix-parents');
    }
  }, []);

  const getNationalities = useCallback(async () => {
    try {
      Notiflix.Block.circle('.notiflix-nationality');
      const { data } = await api.get(`/generic/list-of-nationality`);
      const { content } = data;
      setNationalityOptions([
        {
          title: '',
          value: '',
        },
        ...content.map(({ name, id }: { name: string; id: string }) => ({
          title: name.toUpperCase(),
          value: id,
        })),
      ]);
    } catch (err) {
      Notiflix.Notify.failure(
        'Ops não conseguimos buscar as cidades para seleção. Por favor, tente novamente mais tarde.',
      );
    } finally {
      Notiflix.Block.remove('.notiflix-nationality');
    }
  }, []);

  const getCitysOfState = useCallback(async (state) => {
    try {
      Notiflix.Block.circle('.notiflix-city');
      const { data } = await api.get(`/address/list-of-cities?state=${state}`);
      Notiflix.Block.circle('.notiflix-city');
      Notiflix.Block.remove('.notiflix-city');
      const { content } = data;

      setCityOptions([
        {
          title: '',
          value: '',
        },
        ...content.map(
          ({ city, ibgeCityCode }: { city: string; ibgeCityCode: string }) => ({
            title: city,
            value: ibgeCityCode,
          }),
        ),
      ]);
    } catch (err) {
      Notiflix.Block.remove('.notiflix-city');
      Notiflix.Notify.failure(
        'Ops não conseguimos buscar as cidades para seleção. Por favor, tente novamente mais tarde.',
      );
    }
  }, []);

  const getAllCountry = useCallback(async () => {
    try {
      Notiflix.Block.circle('.notiflix-country');
      const { data } = await api.get(`/address/list-of-countries`);
      const { content } = data;
      setCountryOptions([
        { title: '', name: '' },
        ...content.map(({ id, name }: { name: string; id: string }) => ({
          title: name,
          value: id,
        })),
      ]);
    } catch (err) {
      Notiflix.Notify.failure(
        'Ops não conseguimos buscar os países para seleção. Por favor, tente novamente mais tarde.',
      );
    } finally {
      Notiflix.Block.remove('.notiflix-country');
    }
  }, []);

  const getAllStates = useCallback(async () => {
    try {
      Notiflix.Block.circle('.notiflix-states');
      Notiflix.Block.circle('.notiflix-uf');
      const { data } = await api.get('/address/list-of-states');
      const { content } = data;
      setStateOptions([
        {
          title: '',
          name: '',
        },
        ...content.map(({ id, name }: { name: string; id: string }) => ({
          title: name,
          value: id,
        })),
      ]);
      setUfOptions([
        { title: '', value: '' },
        ...content.map(({ id }: { id: string }) => ({
          title: id,
          value: id,
        })),
      ]);
    } catch (err) {
      Notiflix.Notify.failure(
        'Ops não conseguimos buscar os estados para seleção. Por favor, tente novamente mais tarde.',
      );
    } finally {
      Notiflix.Block.remove('.notiflix-states');
      Notiflix.Block.remove('.notiflix-uf');
    }
  }, []);

  const getAllMaritalStatus = useCallback(async () => {
    try {
      Notiflix.Block.circle('.notiflix-marital');
      const { data } = await api.get('/generic/list-of-marital-status');
      const { content } = data;
      setMaritalOptions([
        {
          title: '',
          value: '',
        },
        ...content.map(({ id, name }: { name: string; id: string }) => ({
          title: name.toUpperCase(),
          value: id,
        })),
      ]);
    } catch (err) {
      Notiflix.Notify.failure(
        'Ops... Não conseguimos buscar os estados civis para seleção. Por favor, tente novamente mais tarde.',
      );
    } finally {
      Notiflix.Block.remove('.notiflix-marital');
    }
  }, []);

  const getAllPhisicalSex = useCallback(async () => {
    try {
      Notiflix.Block.circle('.notiflix-phisical-sex');
      const { data } = await api.get('/generic/list-of-phisical-sex');
      const { content } = data;
      setPhisicalSexOptions([
        { title: '', value: '' },
        ...content.map(({ id, name }: { name: string; id: string }) => ({
          title: name.toUpperCase(),
          value: id,
        })),
      ]);
    } catch (err) {
      Notiflix.Notify.failure(
        'Ops... Não conseguimos buscar a lista de seleção de sexo no servidor. Por favor, tente novamente mais tarde.',
      );
    } finally {
      Notiflix.Block.remove('.notiflix-phisical-sex');
    }
  }, []);

  const getAllReasonForInclusion = useCallback(async () => {
    try {
      Notiflix.Block.circle('.notiflix-reason-inclusion');
      const { data } = await api.get(
        '/beneficiary/list-of-reasons-for-inclusion',
      );
      const { content } = data;
      setReasonForInclusionOptions(
        content.map(({ id, name }: { name: string; id: string }) => ({
          title: name,
          value: id,
        })),
      );
    } catch (err) {
      Notiflix.Notify.failure(
        'Ops... Não conseguimos buscar os motivos para inclusão para seleção. Por favor, tente novamente mais tarde.',
      );
    } finally {
      Notiflix.Block.remove('.notiflix-reason-inclusion');
    }
  }, []);

  const getAllAttachmentsTypes = useCallback(async () => {
    try {
      const DEPENDENT = 1;
      const { data } = await api.get(
        `/beneficiary-inclusion/attachment-rules?typeOfBeneficiary=${DEPENDENT}`,
      );
      const { content } = data;
      setAllAttachmentsTypes(content);
    } catch (err) {
      Notiflix.Notify.failure(
        'Ops... Não conseguimos buscar as regras de anexo. Por favor, tente novamente mais tarde.',
      );
    }
  }, []);

  const getAllpreloadedUser = useCallback(async () => {
    const { data } = await api.get(
      `/beneficiary-inclusion/consult-solicitation-for-editing?requestId=${preloadOfRequestId}&editMode=true`,
    );
    const { content } = data;
    const [userContent] = content;

    if (!formRef.current || !userContent) return;

    const fullPhone =
      (userContent.DDDNumberPhone ?? '') + (userContent.telephone ?? '');
    const fullCellphone =
      (userContent.dddCellPhone ?? '') + (userContent.cellphone ?? '');
    formRef.current.setFieldValue(
      'dependentName',
      userContent.beneficiaryName || '',
    );
    formRef.current.setFieldValue('email', userContent.email || '');
    formRef.current.setFieldValue('phone', fullPhone || '');
    formRef.current.setFieldValue('cellphone', fullCellphone || '');
    formRef.current.setFieldValue('cpf', userContent.cpf || '');
    formRef.current.setFieldValue('rg', userContent.rg || '');
    formRef.current.setFieldValue(
      'organ',
      userContent.issuingBodyDescriptionRg || '',
    );
    formRef.current.setFieldValue('father', userContent.fatherName || '');
    formRef.current.setFieldValue('mother', userContent.mother || '');
    formRef.current.setFieldValue(
      'passportNumber',
      userContent.passportId || '',
    );

    formRef.current.setFieldValue('product', userContent.planId || '');
    formRef.current?.setFieldValue(
      'reasonForInclusion',
      userContent.motiveIncludeId,
    );

    if (userContent.datePlanAgreementOrigin) {
      const [datePlanDay, datePlanMonth, datePlanYear] =
        userContent.datePlanAgreementOrigin.split('/');
      formRef.current.setFieldValue(
        'contractDateOfOriginPlan',
        new Date(datePlanYear, datePlanMonth - 1, datePlanDay),
      );
    }

    formRef.current.setFieldValue(
      'priceOfOriginPlan',
      String(userContent.sourcePlanPriceValue)
        .replace('.', '')
        .replace(',', ''),
    );

    formRef.current.setFieldValue(
      'ANSGuideProtocolNumber',
      userContent.ansGuideProtocolNumber,
    );

    if (userContent.protocolIssueDate) {
      const [issueProtocolDay, issueProtocolMonth, issueProtocolYear] =
        userContent.protocolIssueDate.split('/');
      formRef.current.setFieldValue(
        'issueProtocolDate',
        new Date(issueProtocolYear, issueProtocolMonth - 1, issueProtocolDay),
      );
    }

    formRef.current.setFieldValue(
      'originOperator',
      userContent.descriptionOperatorOrigin,
    );

    formRef.current.setFieldValue(
      'coverageGeographicalOriginalPlan',
      userContent.codeCoveragePlanOrigin,
    );
    formRef.current.setFieldValue(
      'registerOfOriginalProduct',
      userContent.sourcePlanRegistrationCode,
    );
    formRef.current.setFieldValue(
      'typeOfContract',
      userContent.typePlanContractOrigin,
    );

    setResponsibleData({
      responsibleName: userContent.responsibleName,
      responsibleCpf: userContent.responsibleCpf,
      responsibleEmail: userContent.responsibleEmail,
      responsibleBirth: userContent.responsibleBirth,
      responsibleCellPhone: userContent.responsibleCellPhone,
      responsibleDddCellPhone: userContent.responsibleDddCellPhone,
      responsibleDegreeKinship: userContent.responsibleDegreeKinship
        ? String(userContent.responsibleDegreeKinship)
        : '',
      responsibleDegreeKinshipDescription:
        userContent.responsibleDegreeKinshipDescription,
    });

    formRef.current.setFieldValue(
      'parents',
      String(userContent.relationshipNumber),
    );
    setParents(String(userContent.relationshipNumber));

    nationalityRef.current?.setValue('', userContent.nationalityCode);

    stateRef.current?.setValue('', userContent.initialsBirthState);

    getCitysOfState(userContent.initialsBirthState).then(() => {
      cityRef.current?.setValue(userContent.descriptionMunicipalityOfBirth);
    });

    countryRef.current?.setValue('', userContent.issuingCountryCode);

    ufRef.current?.setValue('', userContent.issuingAgencyState);
    phisicalSexRef.current?.setValue('', userContent.physicalSex);
    maritalRef.current?.setValue('', userContent.maritalStatus);
    formRef.current.setFieldValue('previousRequestId', userContent.requestId);

    if (userContent.birthDate) {
      const [birthDay, birthMonth, birthYear] =
        userContent.birthDate.split('/');
      setBirthDate({
        value: new Date(birthYear, birthMonth - 1, birthDay),
        error: '',
      });
    }
    if (userContent.responsibleBirth) {
      const [birthDay, birthMonth, birthYear] =
        userContent.responsibleBirth.split('/');

      setResponsibleBirth({
        value: new Date(birthYear, birthMonth - 1, birthDay),
        error: '',
      });
    }

    if (userContent.emissionDate) {
      const [rgDispDay, rgDispMonth, rgDispYear] =
        userContent.emissionDate.split('/');
      setRgDispatchDate({
        value: new Date(rgDispYear, rgDispMonth - 1, rgDispDay),
        error: '',
      });
    }

    if (userContent.nrSeqTitularContrato) {
      setIdOfOwnerRequiredByContract(userContent.nrSeqTitularContrato);
    }

    const files: File[] = [];
    const allFiles = await Promise.allSettled<AxiosResponse<Blob>[]>(
      userContent.attachments.map((resp: { id: string; name: string }) =>
        api.get(
          `/beneficiary-inclusion/consult-solicitation-for-editing?requestId=${preloadOfRequestId}&fileId=${resp.id}&fileName=${resp.name}`,
          { responseType: 'blob' },
        ),
      ),
    );

    allFiles.forEach((promise) => {
      if (promise.status === 'fulfilled') {
        const field = promise.value.config.url?.split('?')[1].split('&');

        if (field) {
          files.push(
            new File(
              [promise.value.data],
              field[0].split('=')[1] + field[1].split('=')[1],
            ),
          );
        }
      }
    });

    const actualAttachmentsGroupShowing = attachmentsRefs.current.find(Boolean);
    if (actualAttachmentsGroupShowing)
      actualAttachmentsGroupShowing.setFiles(files);

    setRequestHolderId(userContent.nrSeqTitularSolicitacao);
  }, [preloadOfRequestId, getCitysOfState]);

  // const getAttachments = useCallback(async () => {
  //   try {
  //     const { data } = await api.get(
  //       `/beneficiary-inclusion/consult-solicitation-for-editing?requestId=${preloadOfRequestId}`,
  //     );
  //     const { content } = data;

  //     if (content) {
  //       // eslint-disable-next-line prefer-const
  //       let files: File[] = [];
  //       const allFiles = await Promise.allSettled<AxiosResponse<Blob>[]>(
  //         content[0].attachments.map((resp: { id: string; name: string }) =>
  //           api.get(
  //             `/beneficiary-inclusion/consult-solicitation-for-editing?requestId=${preloadOfRequestId}&fileId=${resp.id}&fileName=${resp.name}`,
  //             { responseType: 'blob' },
  //           ),
  //         ),
  //       );

  //       allFiles.forEach((promise) => {
  //         if (promise.status === 'fulfilled') {
  //           const field = promise.value.config.url?.split('?')[1].split('&');

  //           if (field) {
  //             files.push(
  //               new File(
  //                 [promise.value.data],
  //                 field[0].split('=')[1] + field[1].split('=')[1],
  //               ),
  //             );
  //           }
  //         }
  //       });

  //       attachmentsRefs.current[3]?.setFiles(files);
  //     }
  //   } catch (err) {
  //     if (err?.response.status === 400) return;
  //     Notiflix.Notify.failure(
  //       'Ops... Não conseguimos buscar os anexos no servidor. Por favor, tente novamente mais tarde.',
  //     );
  //   }
  // }, [preloadOfRequestId]);

  const unlockAllInputs = useCallback(() => {
    if (formRef.current) {
      Object.keys(formRef.current.getData()).forEach((key) => {
        if (formRef.current?.getFieldRef(key).current) {
          formRef.current?.getFieldRef(key).current.removeAttribute('disabled');
        }
      });
    }
    if (callbackShowReleaseButton) {
      callbackShowReleaseButton();
    }
  }, [callbackShowReleaseButton]);

  const handleSaveAndReleaseRegister = useCallback(async () => {
    if (!isExternalLink && !requestHolderId) {
      Notiflix.Block.circle('.notiflix-dependent-save-release');
    }
    let reqId = '';
    const data = formRef.current?.getData();
    if (requestId) {
      reqId = await handleSubmitEdit(
        data,
        `.notiflix-dependent-send-edit-${requestId}`,
      );
    } else {
      reqId = await handleSubmit(data, `.notiflix-dependent-send-${requestId}`);
    }

    if (reqId) {
      await handleReleaseRegister(reqId);
    }

    if (!isExternalLink && !requestHolderId) {
      Notiflix.Block.remove('.notiflix-dependent-save-release');
    }
    return !!reqId;
  }, [
    handleReleaseRegister,
    handleSubmit,
    handleSubmitEdit,
    isExternalLink,
    requestHolderId,
    requestId,
  ]);

  const handleChangeInput = (
    event: React.ChangeEvent<HTMLInputElement>,
    name: string,
  ) => {
    if (
      name === 'dependentName' ||
      name === 'mother' ||
      name === 'father' ||
      name === 'organ' ||
      name === 'responsibleName'
    ) {
      const result = event.target.value
        .normalize('NFD')
        .replace(/[^a-zA-Z( )]/g, '')
        .toUpperCase();
      formRef.current?.setFieldValue(name, result);
      // eslint-disable-next-line eqeqeq
    } else if (name == 'responsibleDegreeKinshipDescription') {
      const result = event.target.value.toUpperCase();
      formRef3.current?.setFieldValue(name, result);
    } else {
      const result = event.target.value.toUpperCase();
      formRef.current?.setFieldValue(name, result);
    }
  };

  const handleResponsibleChangeInput = (
    event: React.ChangeEvent<HTMLInputElement>,
    name: string,
  ) => {
    if (name === 'responsibleName') {
      const result = event.target.value
        .normalize('NFD')
        .replace(/[^a-zA-Z( )]/g, '')
        .toUpperCase();
      formRef3.current?.setFieldValue(name, result);
      // eslint-disable-next-line eqeqeq
    } else if (name == 'responsibleDegreeKinshipDescription') {
      const result = event.target.value.toUpperCase();
      otherFormRef.current?.setFieldValue(name, result);
    } else {
      const result = event.target.value.toUpperCase();
      formRef3.current?.setFieldValue(name, result);
    }
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     getAttachments();
  //   }, 1000);
  // }, [getAttachments]);

  useEffect(() => {
    Promise.all([
      getAllParents(),
      getAllStates(),
      getAllCountry(),
      getAllMaritalStatus(),
      getAllPhisicalSex(),
      getAllReasonForInclusion(),
      getAllAttachmentsTypes(),
      getNationalities(),
    ]).then(() => {
      if (preloadOfRequestId) {
        // carregar todos os dados do usuário a ser editado;
        getAllpreloadedUser();
        // getAttachments();
        if (!disabled) {
          setRequestId(preloadOfRequestId);
        }
      }
    });

    // dispatch action to controller button on url path 'incluir-beneficiario'
    window.dispatchEvent(new Event('controllerOfSaveAndReleaseAction'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preloadOfRequestId]);

  useEffect(() => {
    if (rowsSelecteds[0].beneficiaryName && rowsSelecteds[0].productName) {
      formRef.current?.setFieldValue('product', rowsSelecteds[0].productName);
    } else if (selectedProduct) {
      formRef.current?.setFieldValue('product', selectedProduct);
    }
  }, [selectedProduct, rowsSelecteds]);

  /* if option parentesRefResponsible for 'outro' show input text
   */
  useEffect(() => {
    const getSelectResponsible = () => {
      setShowInputOtherParents(String(responsibleDegreeKinship) === '99');
    };
    getSelectResponsible();
  }, [responsibleDegreeKinship]);

  const formActions = useMemo(() => {
    if (isExternalLink && requestId) {
      return <></>;
    }

    if (requestId) {
      return (
        <FormWrapper
          onSubmit={() => {
            //
          }}
          formLook
          className="actions-include-dependent"
        >
          {showActionsButtons && (
            <Button
              secondary
              autoWidth
              formLook
              onClick={() => callbackSetStep(1)}
              style={{ marginRight: 'auto' }}
            >
              Voltar
            </Button>
          )}
          {showActionsButtons && (
            <Button
              greenCriticalButton
              autoWidth
              formLook
              onClick={() => handleReport(requestId)}
              className={`notiflix-dependent-report-${requestId}`}
            >
              Imprimir
            </Button>
          )}
          {!hiddenRelease && (
            <Button
              greenPrimary
              autoWidth
              formLook
              className={`notiflix-dependent-send-edit-${requestId}`}
              onClick={() => {
                handleSubmitEdit(
                  formRef.current?.getData(),
                  `.notiflix-dependent-send-edit-${requestId}`,
                );
              }}
            >
              Salvar
            </Button>
          )}
          {showActionsButtons &&
            !hiddenRelease &&
            refreshedAttachments &&
            attachmentsRefs.current.filter((r) => r.files && r.files.length > 0)
              .length > 0 && (
              <Button
                orangeButton
                autoWidth
                formLook
                onClick={() => handleSaveAndReleaseRegister()}
                style={{ marginLeft: '0' }}
                className="notiflix-dependent-save-release"
              >
                Salvar e Liberar
              </Button>
            )}
        </FormWrapper>
      );
    }
    return (
      <FormWrapper
        onSubmit={() => {
          //
        }}
        formLook
        className="actions-include-dependent"
      >
        {showTitle && (
          <Button
            secondary
            autoWidth
            formLook
            onClick={() => callbackSetStep(1)}
            style={{ marginRight: 'auto' }}
          >
            Voltar
          </Button>
        )}

        {!disabled && (
          <Button
            greenPrimary
            autoWidth
            formLook
            className={`notiflix-dependent-send-${requestId} ${
              isExternalLink && 'marginLeft'
            }`}
            onClick={() => {
              handleSubmit(
                formRef.current?.getData(),
                `.notiflix-dependent-send-${requestId}`,
              );
            }}
          >
            Salvar
          </Button>
        )}
        {!isExternalLink &&
          !requestHolderId &&
          !hiddenRelease &&
          refreshedAttachments &&
          attachmentsRefs.current.filter((r) => r.files && r.files.length > 0)
            .length > 0 && (
            <Button
              orangeButton
              autoWidth
              formLook
              onClick={() => handleSaveAndReleaseRegister()}
              style={{ marginLeft: '0' }}
              className="notiflix-dependent-save-release"
            >
              Salvar e Liberar
            </Button>
          )}
        {disabled && showNewButton && (
          <Button
            grayButton
            autoWidth
            formLook
            className={`notiflix-dependent-send-${requestId}`}
            onClick={() => {
              setDisabled(false);
              unlockAllInputs();
            }}
          >
            Novo
          </Button>
        )}
      </FormWrapper>
    );
  }, [
    callbackSetStep,
    disabled,
    handleReport,
    handleSubmit,
    handleSubmitEdit,
    hiddenRelease,
    refreshedAttachments,
    requestId,
    showTitle,
    unlockAllInputs,
    handleSaveAndReleaseRegister,
    isExternalLink,
    requestHolderId,
    showActionsButtons,
    showNewButton,
  ]);

  useEffect(() => {
    if (!allAttachmentsTypes) return;
    const found = allAttachmentsTypes.filter(
      (i) => String(i.relationship) === String(parents),
    );
    if (found.length > 0) {
      setAttachmentsTypes(found);
    } else {
      setAttachmentsTypes([]);
    }
  }, [allAttachmentsTypes, parents]);

  const attachments = useMemo(() => {
    if (isExternalLink && requestId) {
      return <></>;
    }

    if (attachmentsTypes.length > 0) {
      return (
        <FormWrapper
          onSubmit={() => {
            //
          }}
          formLook
          ref={formRef2}
          style={{ display: 'flex', flexWrap: 'wrap', marginTop: '24px' }}
        >
          <TitleIntern themeColor={defaultColor}>Anexos</TitleIntern>
          {attachmentsTypes.map((rel) => {
            return (
              <InputFile
                multiple
                key={`attachment-${rel.id}`}
                name={`attachment-${rel.id}`}
                title={rel.name}
                placeholder={rel.name}
                required={rel.mandatory === '1'}
                themeColor={defaultColor}
                callbackHasChanged={() => {
                  refreshAttachments(v4());

                  // dispatch action to controller button on url path 'incluir-beneficiario'
                  window.dispatchEvent(
                    new Event('controllerOfSaveAndReleaseAction'),
                  );
                }}
                ref={(el) => {
                  if (el) {
                    attachmentsRefs.current[Number(rel.id)] = el;
                  }
                }}
              />
            );
          })}
        </FormWrapper>
      );
    }
    return <></>;
  }, [attachmentsTypes, defaultColor, isExternalLink, requestId]);

  const getFirsContainerError = useCallback(() => {
    const types = attachmentsTypes.find((type) => {
      return (
        type.mandatory === '1' &&
        (!attachmentsRefs.current[Number(type.id)].files ||
          attachmentsRefs.current[Number(type.id)].files?.length === 0)
      );
    });
    if (types) {
      return attachmentsRefs.current[Number(types.id)].containerRef;
    }
    return null;
  }, [attachmentsTypes]);

  const containAllFiles = useCallback(() => {
    return (
      attachmentsTypes.filter((type) => {
        let error = false;
        if (
          type.mandatory === '1' &&
          (!attachmentsRefs.current[Number(type.id)].files ||
            attachmentsRefs.current[Number(type.id)].files?.length === 0)
        ) {
          attachmentsRefs.current[Number(type.id)].setError(
            'É necessário informar esse anexo.',
          );
          error = true;
        }
        return error;
      }).length === 0
    );
  }, [attachmentsTypes]);

  const parentsReducer = useCallback(
    (content: { id: number; name: string; typeKinship: string }[]) => {
      return [
        { id: '-1', name: '' },
        ...content
          .filter((op) => op.typeKinship === 'BENEF')
          .map((i) => ({
            id: String(i.id),
            name: i.name,
          })),
      ];
    },
    [],
  );

  const parentsCallbackOnChange = useCallback((_: string, id: string) => {
    setParents(id);
  }, []);

  useImperativeHandle(ref, () => {
    return {
      containAllFiles,
      saveAndRelease: handleSaveAndReleaseRegister,
      firstContainerRefError: getFirsContainerError,
      validateForm,
      dispatchSaveEdit: handleSubmitEdit,
    };
  });

  /**
   * When has change attachments render, is dispatch event to controllerOfSaveAndReleaseAction to work in page beneficiary include
   */
  useEffect(() => {
    window.dispatchEvent(new Event('controllerOfSaveAndReleaseAction'));
  }, [attachments]);

  return (
    <>
      {showTitle && (
        <TitleIntern themeColor={defaultColor}>
          Titular: {rowsSelecteds[0].beneficiaryName}
        </TitleIntern>
      )}
      {!showTitle && (
        <TitleIntern themeColor={defaultColor}>
          Inclusão de dependente
        </TitleIntern>
      )}
      <FormWrapper
        onSubmit={() => {
          console.log('N/A');
        }}
        formLook
        className="depentent-include"
        ref={formRef}
      >
        <Input
          name="dependentName"
          title="Nome do dependente:"
          formLook
          widthContainerDesktop="25%"
          themeColor={defaultColor}
          disabled={disabled}
          onChange={(event) => handleChangeInput(event, 'dependentName')}
        />
        <Input
          name="email"
          title="E-mail:"
          formLook
          widthContainerDesktop="25%"
          themeColor={defaultColor}
          disabled={disabled}
          onChange={(event) => handleChangeInput(event, 'email')}
        />

        <SelectUnform
          name="reasonForInclusion"
          title="Motivo de inclusão:"
          apiSearch="/beneficiary/list-of-reasons-for-inclusion"
          formLook
          callbackOnChange={(name, id) => {
            setIncludeReason({ name, id });
          }}
          widthContainerDesktop="50%"
          disabled={disabled}
          themeColor={defaultColor}
        />

        {/* <Select
          name="reasonForInclusion"
          title="Motivo de inclusão:"
          ref={reasonForInclusionRef}
          options={reasonForInclusionOptions}
          className="notiflix-reason-inclusion"
          callbackOnChange={(name, id) => {
            setIncludeReason({ name, id });
          }}
          liveReload
          formLook
          themeColor={defaultColor}
          widthContainerDesktop="25%"
          disabled={disabled}
        /> */}

        <SelectUnform
          name="parents"
          title="Grau de parentesco:"
          apiSearch="/generic/relationship"
          personalReducer={parentsReducer}
          className="notiflix-parents"
          formLook
          themeColor={defaultColor}
          callbackOnChange={parentsCallbackOnChange}
          widthContainerDesktop="50%"
          disabled={disabled}
        />

        <SelectUnform
          name="product"
          title="Produto:"
          apiSearch={
            rowsSelecteds[0].contractId || contractId
              ? `/company/product-listing-for-selection?contractId=${
                  rowsSelecteds[0].contractId || contractId
                }`
              : ''
          }
          formLook
          widthContainerDesktop="50%"
          disabled={
            rowsSelecteds[0].beneficiaryName || selectedProduct
              ? true
              : disabled
          }
          themeColor={defaultColor}
        />
        <OptionalParams
          className={includeReason.name === 'PORTABILIDADE' ? 'show' : ''}
        >
          <DatePickerUnform
            name="contractDateOfOriginPlan"
            title="Data de contratação do plano de origem:"
            icon
            formLook
            widthContainerDesktop="25%"
            disabled={disabled}
            themeColor={defaultColor}
          />
          <Input
            name="priceOfOriginPlan"
            title="Preço do plano de origem:"
            formLook
            widthContainerDesktop="25%"
            disabled={disabled}
            themeColor={defaultColor}
            masks={[
              '9,99',
              '99,99',
              '999,99',
              '9.999,99',
              '99.999,99',
              '999.999,99',
              '9.999.999,99',
              '99.999.999,99',
              '999.999.999,99',
              '9.999.999.999,99',
            ]}
          />
          <Input
            name="ANSGuideProtocolNumber"
            title="Nº protocolo guia ANS:"
            formLook
            widthContainerDesktop="25%"
            disabled={disabled}
            themeColor={defaultColor}
            onChange={(event) =>
              handleChangeInput(event, 'ANSGuideProtocolNumber')
            }
          />
          <DatePickerUnform
            name="issueProtocolDate"
            title="Data de emissão do protocolo:"
            icon
            formLook
            widthContainerDesktop="25%"
            disabled={disabled}
            themeColor={defaultColor}
          />
          <Input
            name="originOperator"
            title="Operadora de origem:"
            formLook
            widthContainerDesktop="25%"
            disabled={disabled}
            themeColor={defaultColor}
            onChange={(event) => handleChangeInput(event, 'originOperator')}
          />
          <SelectUnform
            name="coverageGeographicalOriginalPlan"
            title="Abrangência geográfica do plano de origem:"
            apiSearch="/domain/geographical-coverage"
            formLook
            widthContainerDesktop="25%"
            disabled={disabled}
            themeColor={defaultColor}
          />
          <Input
            name="registerOfOriginalProduct"
            title="Registro do produto de origem:"
            formLook
            widthContainerDesktop="25%"
            disabled={disabled}
            themeColor={defaultColor}
            onChange={(event) =>
              handleChangeInput(event, 'registerOfOriginalProduct')
            }
          />
          <SelectUnform
            name="typeOfContract"
            title="Tipo de contratação:"
            apiSearch="/domain/hiring-type-list"
            formLook
            widthContainerDesktop="25%"
            disabled={disabled}
            themeColor={defaultColor}
          />
        </OptionalParams>

        <DatePicker
          name="birhDate"
          title="Data de nascimento"
          selected={birthDate.value}
          error={birthDate.error}
          onChange={(date: Date) => setBirthDate({ value: date, error: '' })}
          themeColor={defaultColor}
          widthContainerDesktop="25%"
          disabled={disabled}
          maxDate={new Date()}
          formLook
          icon
        />
        <Input
          name="cellphone"
          title="DDD/Celular:"
          masks={['(99) 9999-9999', '(99) 9 9999-9999']}
          formLook
          widthContainerDesktop="25%"
          themeColor={defaultColor}
          disabled={disabled}
        />
        <Input
          name="phone"
          title="DDD/Telefone:"
          masks={['(99) 9999-9999', '(99) 9 9999-9999']}
          formLook
          widthContainerDesktop="25%"
          themeColor={defaultColor}
          disabled={disabled}
        />
        <Select
          name="nationality"
          title="Nacionalidade:"
          ref={nationalityRef}
          options={nationalityOptions}
          inputMode
          className="notiflix-nationality select-nationality"
          liveReload
          formLook
          themeColor={defaultColor}
          widthContainerDesktop="25%"
          disabled={disabled}
        />

        <Select
          name="state"
          title="Estado de nascimento:"
          ref={stateRef}
          options={statesOptions}
          changeCallback={getCitysOfState}
          inputMode
          className="notiflix-states select-state"
          liveReload
          formLook
          themeColor={defaultColor}
          widthContainerDesktop="25%"
          disabled={disabled}
        />
        <Select
          name="city"
          title="Cidade de nascimento:"
          ref={cityRef}
          options={cityOptions}
          className="notiflix-city select-city"
          liveReload
          inputMode
          formLook
          themeColor={defaultColor}
          widthContainerDesktop="25%"
          disabled={disabled}
        />
        <Input
          name="cpf"
          title="CPF:"
          masks={['999.999.999-99']}
          formLook
          widthContainerDesktop="20%"
          themeColor={defaultColor}
          disabled={disabled}
        />

        <Input
          name="rg"
          title="RG:"
          formLook
          widthContainerDesktop="20%"
          disabled={disabled}
          themeColor={defaultColor}
          onChange={(event) => handleChangeInput(event, 'rg')}
        />
        <Select
          name="country"
          title="País emissor:"
          ref={countryRef}
          options={countryOptions}
          className="notiflix-country"
          liveReload
          formLook
          themeColor={defaultColor}
          widthContainerDesktop="10%"
          disabled={disabled}
        />
        <Input
          name="organ"
          title="Órgão:"
          formLook
          widthContainerDesktop="10%"
          themeColor={defaultColor}
          disabled={disabled}
          onChange={(event) => handleChangeInput(event, 'organ')}
        />
        <Select
          name="uf"
          title="UF:"
          ref={ufRef}
          options={ufOptions}
          className="notiflix-uf select-uf"
          liveReload
          formLook
          themeColor={defaultColor}
          widthContainerDesktop="10%"
          disabled={disabled}
        />
        <DatePicker
          name="rgDispatchDate"
          title="Data Exp. RG:"
          selected={rgDispatchDate.value}
          error={rgDispatchDate.error}
          onChange={(date: Date) => {
            setRgDispatchDate({ value: date, error: '' });
          }}
          formLook
          themeColor={defaultColor}
          widthContainerDesktop="15%"
          icon
          disabled={disabled}
        />
        <Select
          name="maritalStatus"
          title="Estado civil:"
          ref={maritalRef}
          options={maritalOptions}
          className="notiflix-marital select-marital-status"
          liveReload
          formLook
          themeColor={defaultColor}
          widthContainerDesktop="15%"
          disabled={disabled}
        />

        <Select
          name="phisicalSex"
          title="Sexo:"
          ref={phisicalSexRef}
          options={phisicalSexOptions}
          className="notiflix-phisical-sex select-genre"
          liveReload
          formLook
          themeColor={defaultColor}
          widthContainerDesktop="20%"
          disabled={disabled}
        />
        <Input
          name="passportNumber"
          title="Nº Passaporte:"
          formLook
          widthContainerDesktop="20%"
          themeColor={defaultColor}
          disabled={disabled}
          onChange={(event) => handleChangeInput(event, 'passportNumber')}
        />
        <Input
          name="father"
          title="Filiação (pai):"
          formLook
          widthContainerDesktop="50%"
          themeColor={defaultColor}
          disabled={disabled}
          onChange={(event) => handleChangeInput(event, 'father')}
        />
        <Input
          name="mother"
          title="Filiação (mãe):"
          formLook
          widthContainerDesktop="50%"
          themeColor={defaultColor}
          disabled={disabled}
          onChange={(event) => handleChangeInput(event, 'mother')}
        />
        <Input name="previousRequestId" hidden />
        <Input name="userUnimedIdHolder" hidden />

        {showLegaLRespBlock.needRespLegal && showLegaLRespBlock.over18 ? (
          <FormWrapper
            onSubmit={() => {
              console.log('N/A');
            }}
            formLook
            className="depentent-response-include"
            ref={formRef3}
            style={{
              width: '100%',
            }}
          >
            <TitleIntern themeColor={defaultColor}>
              RESPONSÁVEL LEGAL
            </TitleIntern>
            <BlockInsideForm>
              <Input
                name="responsibleName"
                title="Nome do Responsável:"
                formLook
                widthContainerDesktop="50%"
                themeColor={defaultColor}
                disabled={disabled}
                onChange={(event) =>
                  handleResponsibleChangeInput(event, 'responsibleName')
                }
              />
              <Input
                name="responsibleCpf"
                title="CPF do Responsável:"
                masks={['999.999.999-99']}
                formLook
                widthContainerDesktop="20%"
                themeColor={defaultColor}
                disabled={disabled}
              />
              <DatePicker
                name="responsibleBirth"
                title="Data de nascimento"
                selected={responsibleBirth.value}
                error={responsibleBirth.error}
                onChange={(date: Date) => {
                  console.log(date);
                  setResponsibleBirth({ value: date, error: '' });
                }}
                themeColor={defaultColor}
                widthContainerDesktop="25%"
                disabled={disabled}
                maxDate={new Date()}
                formLook
                icon
              />
              <Input
                name="responsiblePhone"
                title="DDD/Celular:"
                masks={['(99) 9999-9999', '(99) 9 9999-9999']}
                formLook
                widthContainerDesktop="25%"
                themeColor={defaultColor}
                disabled={disabled}
              />

              <Input
                name="responsibleEmail"
                title="E-mail:"
                formLook
                widthContainerDesktop="25%"
                themeColor={defaultColor}
                disabled={disabled}
                onChange={(event) =>
                  handleResponsibleChangeInput(event, 'responsibleEmail')
                }
              />
              <Select
                name="responsibleDegreeKinship"
                title="Grau de parentesco:"
                ref={parentsRefResponsible}
                options={responsibleParentsOptions}
                className="notiflix-parents"
                formLook
                themeColor={defaultColor}
                changeCallback={(e) => {
                  setParentsResponsible(e);
                }}
                widthContainerDesktop="50%"
                disabled={disabled}
              />

              {showInputOtherParents && (
                <FormWrapper
                  onSubmit={() => {
                    console.log('N/A');
                  }}
                  ref={otherFormRef}
                  style={{
                    width: '100%',
                    boxShadow: 'none',
                    marginTop: 4,
                    padding: 0,
                  }}
                >
                  <Input
                    name="responsibleDegreeKinshipDescription"
                    title="Outro(a)"
                    formLook
                    widthContainerDesktop="25%"
                    themeColor={defaultColor}
                    disabled={disabled}
                    onChange={(event) =>
                      handleResponsibleChangeInput(
                        event,
                        'responsibleDegreeKinshipDescription',
                      )
                    }
                  />
                </FormWrapper>
              )}
            </BlockInsideForm>
          </FormWrapper>
        ) : (
          <></>
        )}
      </FormWrapper>

      {!disabled && <>{attachments}</>}

      {formActions}
    </>
  );
};

export default forwardRef(DepentendInclude);
